"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("swiper/react");
var Slide_1 = __importDefault(require("./Slide"));
require("./styles.scss");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("swiper/css/lazy");
var DesktopProviders = function (_a) {
    var providers = _a.providers;
    if (providers.length === 0)
        return null;
    return (react_1.default.createElement("div", { id: "providers", className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "providers-slider" },
            react_1.default.createElement(react_2.Swiper, { loop: false, slidesPerView: "auto", slidesPerGroupAuto: true, spaceBetween: 12, speed: 450, freeMode: false, pagination: {
                    clickable: true,
                    dynamicBullets: true,
                }, preloadImages: false, lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 8,
                } }, providers.map(function (provider, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slideProviders".concat(idx), style: { width: 90 } },
                react_1.default.createElement(Slide_1.default, { provider: provider }))); })))));
};
exports.default = DesktopProviders;
